import type React from 'react';
import {
  type Descendant,
  type Element as SlateElement,
  type Path,
} from 'slate';
import Debug from 'debug';
import {
  type HtmlSerializerContext,
  type HtmlSerializerOptions,
} from '../HtmlSerializer';

const debug = Debug('aha-editor-v2:serialization');

export interface MarkAttributes {
  [key: string]: string | boolean;
}

export type HtmlChildrenFunc = (
  childElements: Element[] | HTMLCollection | NodeList,
  markAttributes: MarkAttributes
) => Descendant[];
export type SlateChildrenFunc = (children: SlateElement[]) => void;

export interface SerializeArguments {
  node: Descendant;
  path: Path;
  children: React.ReactNode[];
  context: any;
  options: HtmlSerializerOptions;
}

export interface DeserializeArguments {
  el: Node;
  markAttributes: MarkAttributes;
  next: HtmlChildrenFunc;
  context: HtmlSerializerContext;
  options: HtmlSerializerOptions;
}

// Base class for HTML serializers.
class Serializer {
  // Convert an HTML element to Slate nodes.
  static deserialize(
    args: DeserializeArguments
  ): Descendant | Descendant[] | undefined | null {
    throw new Error('The deserialize function is not implemented');
  }

  // Convert a Slate node to HTML elements (in the form of React nodes).
  static serialize(args: SerializeArguments): React.ReactNode {
    debug(
      'The serialize function is not implemented for ',
      JSON.stringify(args.node)
    );
    return null;
  }
}

export default Serializer;
